class CartDrawerUpsells extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    console.log('Binding events for cart drawer upsells...');
    
    // Handle variant selection changes - use event delegation
    document.addEventListener('change', (event) => {
      console.log('Change event triggered:', event.target.name);
      if (event.target.name === 'variant_id_custom') {
        console.log('Variant change detected');
        this.handleVariantChange(event.target);
      }
    });

    // Handle add to cart button clicks - use event delegation
    document.addEventListener('click', (event) => {
      console.log('Click event triggered on:', event.target);
      console.log('Click event target classes:', event.target.classList);
      
      // Check if the clicked element or any of its parents has the class
      let target = event.target;
      while (target && target !== document) {
        if (target.classList && target.classList.contains('add_to_cart_ajax')) {
          console.log('Add to cart button clicked');
          event.preventDefault();
          event.stopPropagation();
          this.handleAddToCart(target);
          return;
        }
        target = target.parentElement;
      }
    });

    // Handle keyboard navigation for accessibility
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        const target = event.target;
        if (target.classList.contains('add_to_cart_ajax')) {
          event.preventDefault();
          this.handleAddToCart(target);
        }
      }
    });
    
    console.log('Events bound successfully');
  }

  handleVariantChange(selectElement) {
    try {
      const productItem = selectElement.closest('.custom_drawer_products_item');
      if (!productItem) {
        console.error('Could not find product item container');
        return;
      }

      const priceElement = productItem.querySelector('.custom_drawer_products_item_price');
      if (!priceElement) {
        console.error('Could not find price element');
        return;
      }

      const selectedOption = selectElement.options[selectElement.selectedIndex];
      if (!selectedOption) {
        console.error('No option selected');
        return;
      }
      
      // Get variant data from the option element
      const variantData = this.getVariantData(selectedOption);
      
      if (variantData) {
        // Update price display
        this.updatePriceDisplay(priceElement, variantData);
      }
    } catch (error) {
      console.error('Error handling variant change:', error);
    }
  }

  getVariantData(optionElement) {
    // Extract variant data from the option element using data attributes
    const variantId = optionElement.value;
    const variantTitle = optionElement.textContent;
    const isAvailable = optionElement.getAttribute('data-available') === 'true';
    const price = optionElement.getAttribute('data-price');
    const comparePrice = optionElement.getAttribute('data-compare-price');
    
    return {
      id: variantId,
      title: variantTitle,
      available: isAvailable,
      price: price,
      compare_price: comparePrice
    };
  }

  updatePriceDisplay(priceElement, variantData) {
    // Update price display using the data from the option element
    let priceHtml = variantData.price;
    
    if (variantData.compare_price && variantData.compare_price !== '') {
      priceHtml += ` <s>${variantData.compare_price}</s>`;
    }
    
    priceElement.innerHTML = priceHtml;
  }

  handleAddToCart(button) {
    console.log('handleAddToCart called with button:', button);
    
    const productItem = button.closest('.custom_drawer_products_item');
    console.log('Product item:', productItem);
    
    const selectElement = productItem.querySelector('select[name="variant_id_custom"]');
    console.log('Select element:', selectElement);
    
    const variantId = selectElement ? selectElement.value : null;
    console.log('Variant ID:', variantId);
    
    if (!variantId) {
      console.error('No variant selected');
      return;
    }

    // Check if variant is available
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    console.log('Selected option:', selectedOption);
    
    if (selectedOption.disabled) {
      console.log('Variant is disabled');
      this.showError(button, 'Variant unavailable');
      return;
    }

    // Show loading state
    const originalText = button.textContent;
    productItem.classList.add('loading');
    button.textContent = 'Adding...';
    button.style.pointerEvents = 'none';

    // Add to cart via AJAX
    this.addToCartAjax(variantId, 1).then(response => {
      if (response.status) {
        // Error occurred
        console.error('Add to cart error:', response.description);
        this.showError(button, response.description || 'Error adding to cart');
      } else {
        // Success
        this.showSuccess(button, 'Added to cart!');
        this.updateCartDrawer(response);
        
        // Hide the product item after successful add (optional)
        setTimeout(() => {
          productItem.style.opacity = '0.5';
          productItem.style.pointerEvents = 'none';
        }, 1000);
      }
    }).catch(error => {
      console.error('Add to cart error:', error);
      this.showError(button, 'Error adding to cart');
    }).finally(() => {
      // Reset button state after a delay
      setTimeout(() => {
        productItem.classList.remove('loading');
        button.textContent = originalText;
        button.style.pointerEvents = 'auto';
        button.style.backgroundColor = '';
        button.style.color = '';
      }, 2000);
    });
  }

  async addToCartAjax(variantId, quantity = 1) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);

    // Get cart drawer for sections
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
    }

    const config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    };

    console.log('Adding to cart:', variantId, quantity);
    console.log('Config:', config);
    console.log('URL:', window.routes.cart_add_url);

    const response = await fetch(`${window.routes.cart_add_url}`, config);
    const result = await parseFetchJson(response);
    console.log('Cart response:', result);
    return result;
  }

  showSuccess(button, message) {
    button.textContent = message;
    button.style.backgroundColor = '#4CAF50';
    button.style.color = 'white';
  }

  showError(button, message) {
    button.textContent = message;
    button.style.backgroundColor = '#f44336';
    button.style.color = 'white';
  }

  updateCartDrawer(cartData) {
    console.log('Updating cart drawer with data:', cartData);
    
    // Trigger cart update event to refresh the drawer using the existing event system
    if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-drawer-upsells',
        cartData: cartData
      });
    }

    // Also try to update cart drawer directly if available
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.renderContents) {
      cartDrawer.renderContents(cartData);
      
      // Re-initialize upsells after content update
      setTimeout(() => {
        console.log('Re-initializing upsells after cart update...');
        initCartDrawerUpsells();
      }, 500);
    }

    // Update cart count and other cart-related elements
    this.updateCartCount(cartData);
  }

  updateCartCount(cartData) {
    // Update cart count bubble
    const cartCountBubble = document.querySelector('.cart-count-bubble span');
    if (cartCountBubble && cartData.item_count !== undefined) {
      cartCountBubble.textContent = cartData.item_count;
    }

    // Update cart icon
    const cartIcon = document.querySelector('#cart-icon-bubble .svg-wrapper');
    if (cartIcon) {
      if (cartData.item_count > 0) {
        cartIcon.innerHTML = '<svg>...</svg>'; // Replace with actual cart icon SVG
      } else {
        cartIcon.innerHTML = '<svg>...</svg>'; // Replace with empty cart icon SVG
      }
    }
  }
}

// Initialize the cart drawer upsells functionality
function initCartDrawerUpsells() {
  console.log('Initializing cart drawer upsells...');
  
  // Create and attach the custom element
  if (!customElements.get('cart-drawer-upsells')) {
    customElements.define('cart-drawer-upsells', CartDrawerUpsells);
  }
  
  // Initialize the functionality
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    console.log('Cart drawer found, initializing upsells...');
    
    // Check if we already have an instance
    if (window.cartDrawerUpsells) {
      console.log('Removing existing instance...');
      // Clean up existing instance if needed
    }
    
    window.cartDrawerUpsells = new CartDrawerUpsells();
    window.cartDrawerUpsellsInitialized = true;
    
    // Test if elements are found
    setTimeout(() => {
      const buttons = document.querySelectorAll('.add_to_cart_ajax');
      const selects = document.querySelectorAll('select[name="variant_id_custom"]');
      console.log(`Found ${buttons.length} add to cart buttons and ${selects.length} variant selects`);
    }, 100);
  } else {
    console.log('Cart drawer not found');
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initCartDrawerUpsells);

// Also initialize when cart drawer is opened
document.addEventListener('cart:opened', initCartDrawerUpsells);

// Listen for cart drawer opening via mutation observer
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
      const cartDrawer = mutation.target;
      if (cartDrawer.hasAttribute('open')) {
        // Cart drawer is now open, initialize upsells functionality
        console.log('Cart drawer opened, initializing upsells...');
        setTimeout(initCartDrawerUpsells, 100);
      }
    }
  });
});

// Start observing the cart drawer
document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    observer.observe(cartDrawer, { attributes: true });
  }
});

// Also try to initialize after a delay to catch any late-loading elements
setTimeout(initCartDrawerUpsells, 1000);

// Test function to verify the script is loading
console.log('Cart drawer upsells script loaded successfully');

// Add a global test function
window.testCartDrawerUpsells = function() {
  console.log('Testing cart drawer upsells...');
  const buttons = document.querySelectorAll('.add_to_cart_ajax');
  console.log('Found', buttons.length, 'add to cart buttons');
  
  buttons.forEach((button, index) => {
    console.log(`Button ${index}:`, button);
    console.log(`Button classes:`, button.classList);
    console.log(`Button text:`, button.textContent);
  });
  
  const selects = document.querySelectorAll('select[name="variant_id_custom"]');
  console.log('Found', selects.length, 'variant selects');
  
  selects.forEach((select, index) => {
    console.log(`Select ${index}:`, select);
    console.log(`Select value:`, select.value);
    console.log(`Select options:`, select.options.length);
  });
}; 